{
  "schemaVersion": 1,
  "slug": "openai",
  "name": "OpenAI",
  "description": "Connect OpenAI accounts for your agents.",
  "categories": [
    "ai"
  ],
  "branding": {
    "logoUrl": "/brands/apps/openai.svg",
    "darkLogoUrl": "/brands/apps/openai-dark.svg"
  },
  "urlPatterns": [
    "https://api.openai.com/*"
  ],
  "methods": [
    {
      "key": "ai-subscription",
      "label": "OpenAI subscription",
      "purpose": "ai",
      "transport": "runtime_auth",
      "auth": "oauth",
      "ai": {
        "provider": "openai",
        "method": "subscription"
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Authenticate an agent with this account.",
      "guidanceMd": "Use your personal account or an explicitly shared company account.",
      "riskTier": "S3"
    },
    {
      "key": "ai-api_key",
      "label": "OpenAI API key",
      "purpose": "ai",
      "transport": "runtime_auth",
      "auth": "api_key",
      "ai": {
        "provider": "openai",
        "method": "api_key"
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Authenticate an agent with this account.",
      "guidanceMd": "Use your personal account or an explicitly shared company account.",
      "riskTier": "S3",
      "credentialFields": [
        {
          "key": "apiKey",
          "label": "API key",
          "type": "password",
          "required": true,
          "placeholder": "Enter API key",
          "secret": true
        }
      ],
      "keyPlacement": {
        "location": "env",
        "name": "OPENAI_API_KEY"
      }
    }
  ]
}
